// Mon Espace focal point picker (see utils.forms.widgets.FocalPointInput).
// A copy of admin/js/focal_point.js on purpose: admin and front scripts stay
// apart. The previews follow the same centring as the public page.
import '../../scss/widget/focal_point.scss';

function parse(value) {
  const parts = (value || '').split(',');
  if (parts.length !== 2) {
    return null;
  }
  const x = parseInt(parts[0], 10);
  const y = parseInt(parts[1], 10);
  return isNaN(x) || isNaN(y) ? null : [x, y];
}

// Same maths as utils.next_gen_image.centered_position.
function centered(point, width, height, ratio) {
  if (!width || !height || !ratio) {
    return point;
  }
  const position = point.slice();
  const axis = width / height > ratio ? 0 : 1;
  const length = axis === 0 ? width : height;
  const crop = axis === 0 ? height * ratio : width / ratio;
  const free = length - crop;
  if (free <= 0) {
    return point;
  }
  const start = point[axis] / 100 * length - crop / 2;
  position[axis] = Math.round(Math.min(Math.max(start / free, 0), 1) * 100);
  return position;
}

function init(field) {
  const input = field.querySelector('.js-focal-value');
  const stage = field.querySelector('.js-focal-stage');
  const image = field.querySelector('.js-focal-image');
  const dot = field.querySelector('.js-focal-dot');
  const label = field.querySelector('.js-focal-label');
  const previews = field.querySelectorAll('.js-focal-preview');
  const fallback = parse(field.dataset.default);

  function render() {
    const point = parse(input.value);
    const shown = point || fallback;
    dot.style.left = shown[0] + '%';
    dot.style.top = shown[1] + '%';
    previews.forEach((preview) => {
      const ratio = preview.clientWidth / preview.clientHeight;
      const position = centered(shown, image.naturalWidth, image.naturalHeight, ratio);
      preview.style.objectPosition = position[0] + '% ' + position[1] + '%';
    });
    label.textContent = point
      ? 'Cadrage choisi pour cette actu.'
      : 'Cadrage par défaut (centré sur le haut de l’image).';
  }

  stage.addEventListener('click', (event) => {
    const box = image.getBoundingClientRect();
    const x = Math.round((event.clientX - box.left) / box.width * 100);
    const y = Math.round((event.clientY - box.top) / box.height * 100);
    input.value = Math.min(100, Math.max(0, x)) + ',' + Math.min(100, Math.max(0, y));
    render();
  });

  field.querySelector('.js-focal-reset').addEventListener('click', () => {
    input.value = '';
    render();
  });

  // A new upload is framed before saving: show it from the file input.
  const fileInput = document.getElementById(field.dataset.fileInput);
  if (fileInput) {
    fileInput.addEventListener('change', () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) {
        return;
      }
      const url = URL.createObjectURL(file);
      image.src = url;
      previews.forEach((preview) => {
        preview.src = url;
      });
      // The point chosen on the previous picture means nothing here.
      input.value = '';
      field.querySelector('.js-focal-layout').hidden = false;
      field.querySelector('.js-focal-empty').hidden = true;
      render();
    });
  }
  image.addEventListener('load', render);
  render();
}

function initAll() {
  document.querySelectorAll('.js-focal-field').forEach(init);
}

// The forms bundle may load after DOMContentLoaded.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
